import {ROUTER_BASENAME} from '@developers/Constants';

export function prependBasename<T extends string>(path: T) {
  return `/${ROUTER_BASENAME}${path}` as const;
}
